import { NomineeReportGenerator } from './nomineeReportGenerator';

export type { PDFGeneratorConfig } from '../reportUtils/base';
export { BasePDFGenerator } from '../reportUtils/base';
export * from '../reportUtils/documentUtils';
export { NomineeReportGenerator } from './nomineeReportGenerator';

export const generateNomineeReportPDF = async (
  nominee: any,
  userName: string,
  imageBase64: string,
) => {
  const generator = new NomineeReportGenerator({
    userName,
    imageBase64,
    title: `Detalle Nómina #${nominee.id}`,
    fileName: `NOMINA-${nominee.id}.pdf`,
    nominee,
  });
  await generator.generate();
};
